import React from "react";
import { Grid, Divider } from "@material-ui/core";
import { useStyles } from "./detailStyles";

const DetailDivider = () => {
  const classes = useStyles();
  return (
    <Grid container justifyContent="center">
      <Grid item xs={12}>
        <Divider className={classes.divider} />
      </Grid>
    </Grid>
  );
};

export default DetailDivider;
